export const passwordNumbers = /\d+/;
export const passwordCase = /[a-zA-Z]+/;

export function isValidPassword(password: string) {
  const minLength = password.length >= 6;
  const maxLength = password.length <= 64;
  const hasNumber = password.match(passwordNumbers) !== null;
  const hasUpperLowerCase = password.match(passwordCase) !== null;

  const isValid = minLength && maxLength && hasNumber && hasUpperLowerCase;

  return {
    isValid,
    minLength,
    maxLength,
    hasNumber,
    hasUpperLowerCase,
  };
}

export const specialCharRegex = /[!@#$%^&*()\-_=+[\]{};':",.<>/?|\\]/;

export function isStrongPassword(password: string) {
  const minLength = password.length >= 8;
  const maxLength = password.length <= 64;
  const hasUppercaseLowercaseAndNumber = /[A-Z]/.test(password) && /[a-z]/.test(password) && /\d/.test(password);
  const hasSpecial = specialCharRegex.test(password);

  const isValid = minLength && maxLength && hasUppercaseLowercaseAndNumber && hasSpecial;

  return {
    isValid,
    minLength,
    maxLength,
    hasUppercaseLowercaseAndNumber,
    hasSpecial,
  };
}
